// src/services/ReprocessService.js
import axios from "axios";
import { N8N_URL } from "../config";

/**
 * Reprocessa uma Ordem de Venda
 * @param {Object} params - parâmetros livres (por ex: { ov: "987654" })
 * Exemplo de payload enviado ao n8n:
 *   { method: "reprocessar_ordem_venda", payload: { ov: "987654" } }
 */
export const reprocessarOrdemVenda = async (params = {}) => {
  try {
    const response = await axios.post(
      N8N_URL,
      { method: "reprocessar_ordem_venda", payload: params },
      { timeout: 180000 }
    );

    const reply =
      response.data?.[0]?.html ||
      "Reprocessamento finalizado. ✅ Verifique o status atualizado.";

    return reply;
  } catch (err) {
    if (err.code === "ECONNABORTED") {
      throw new Error("Tempo limite excedido. Tente novamente mais tarde.");
    }
    console.error("Erro ao reprocessar OV (n8n):", err);
    throw err;
  }
};
